if ( typeof PickupAvailabilityCompact !== 'function' ) {

  class PickupAvailabilityCompact extends HTMLElement {

    constructor(){

      super();
      this.classList.add('active');

      this.storeSelector = document.querySelector('store-selector[data-main-selector]');
      if ( this.storeSelector ) {
        const STORE_CHANGED_EVENT = () => {
          this.fetchAvailability(this.dataset.variantId, true);
        }
        this.storeSelector.addEventListener('storechanged', STORE_CHANGED_EVENT);
				const observer = new MutationObserver(()=>{
          this.storeSelector.removeEventListener('storechanged', STORE_CHANGED_EVENT);
					observer.disconnect();
				});
				observer.observe(this.parentElement, {
					attributes: false, childList: true, subtree: false
				});
      }

      if ( this.hasAttribute('data-static') ) {
        this.fetchAvailability(this.dataset.variantId);
      } else {
        const widgetIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.fetchAvailability(this.dataset.variantId);
        }
        new IntersectionObserver(widgetIntersection.bind(this), {rootMargin: '0px 0px 50px 0px'}).observe(this);
      }
      
    }

    fetchAvailability(variantId, forceFetch = false) {

      const pickupAvailabilityData = this.querySelector('[data-js-pickup-availability-data]');

      if ( pickupAvailabilityData && ! forceFetch ) {
        this.renderPreview(pickupAvailabilityData);
      } else {

        const variantSectionUrl = `${this.dataset.baseUrl.endsWith('/')?this.dataset.baseUrl:`${this.dataset.baseUrl}/`}variants/${variantId}/?section_id=helper-pickup-availability-compact`;

        fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            console.log(e);
          });

      }

    }
    
    renderPreview(sectionInnerHTML) {
  const selectedStore = localStorage.getItem('selected-store');
  const card = this.closest('.product-item');

  if (this.storeSelector && selectedStore && this.storeSelector.storesList[selectedStore]) {
    let matchedAlert = null;
    let isAvailableInSelectedStore = false;

    sectionInnerHTML.querySelectorAll('.pickup-availability-alert').forEach((elm) => {
      if (selectedStore == elm.dataset.store) {
        matchedAlert = elm;
      }
    });

    if (matchedAlert) {
      this.innerHTML = matchedAlert.innerHTML.replace(
        '{{ store }}',
        this.storeSelector.storesList[selectedStore]
      );

      const alertStatus = matchedAlert.querySelector('.alert');

      if (alertStatus) {
        if (alertStatus.classList.contains('alert--success')) {
          isAvailableInSelectedStore = true;
        } else if (alertStatus.classList.contains('alert--note')) {
          isAvailableInSelectedStore = false;
        }
      }
    } else {
      const unavailableAlert = sectionInnerHTML.querySelector(
        '.pickup-availability-alert[data-default-unavailable]'
      );

      if (unavailableAlert) {
        this.innerHTML = unavailableAlert.innerHTML.replace(
          '{{ store }}',
          this.storeSelector.storesList[selectedStore]
        );
      } else {
        this.innerHTML = '';
      }

      isAvailableInSelectedStore = false;
    }

    if (card) {
      //card.style.display = isAvailableInSelectedStore ? '' : 'none';
    }
  } else {
    const defaultStoreAlert = sectionInnerHTML.querySelector(
      '.pickup-availability-alert[data-default-store]'
    );

    if (defaultStoreAlert) {
      this.innerHTML = defaultStoreAlert.innerHTML;
    } else {
      this.innerHTML = '';
    }

    if (card) {
      //card.style.display = '';
    }
  }
}
    
  }

  if ( typeof customElements.get('pickup-availability-compact') == 'undefined' ) {
    customElements.define('pickup-availability-compact', PickupAvailabilityCompact);
	}

}